/* global sketchup:false */

export default {
    methods: {
        getDefinitionNumber(definition) {
            let idx = definition.lastIndexOf('#');
            if (idx < 0) {
                return '';
            }
            return definition.substring(idx + 1);
        },
        getDefinitionsToRenumber(definitions, definitionNamesToProcess, start) {
            let first = parseInt(start);
            let sortedDefinitions = this.sortDefinitions(definitions);
            let toRenumber = [];
            let toRenumberForCurrentDefinitionName = [];
            let currentDefinitionName = null;

            function processToRenumberForCurrentDefinitionName() {
                let usedNumbers = toRenumberForCurrentDefinitionName.map(d => d.definitionNumber);
                let last = first + toRenumberForCurrentDefinitionName.length - 1;
                let next = first;

                toRenumberForCurrentDefinitionName.forEach(d => {
                    if (d.definitionNumber === null || d.definitionNumber < first || d.definitionNumber > last) {
                        while (usedNumbers.includes(next)) next++;
                        usedNumbers.push(next);
                        toRenumber.push({
                            old: d.old,
                            new: d.definitionName + '#' + next,
                        });
                    }
                });
            }

            sortedDefinitions.forEach(definition => {
                let idx = definition.lastIndexOf("#");
                let definitionName = idx === -1 ? definition : definition.substring(0, idx);
                let definitionNumber = idx === -1 ? null : (definition.substring(idx + 1) ? parseInt(definition.substring(idx + 1)) : null);

                if (currentDefinitionName !== definitionName && toRenumberForCurrentDefinitionName.length > 0) {
                    processToRenumberForCurrentDefinitionName();
                    toRenumberForCurrentDefinitionName = [];
                }

                if (!definitionNamesToProcess || definitionNamesToProcess.includes(definitionName)) {
                    currentDefinitionName = definitionName;
                    toRenumberForCurrentDefinitionName.push({
                        old: definition,
                        definitionName: definitionName,
                        definitionNumber: definitionNumber,
                    });
                }
            });
            if (toRenumberForCurrentDefinitionName.length > 0) {
                processToRenumberForCurrentDefinitionName();
            }

            return toRenumber;
        },
        isVersionGreaterOrEqual(version, reference_version) {
            if (version && reference_version) {
                let plugin_major_minor_patch = version.split('.');
                let minimum_required_major_minor_patch = reference_version.split('.');
                if (plugin_major_minor_patch.length === 3 && minimum_required_major_minor_patch.length === 3) {
                    for (let i = 0; i < 3; i++) {
                        if (parseInt(plugin_major_minor_patch[i]) !== parseInt(minimum_required_major_minor_patch[i])) {
                            return (parseInt(plugin_major_minor_patch[i]) > parseInt(minimum_required_major_minor_patch[i]));
                        }
                    }
                    return true;
                }
            }
            return false;
        },
        punchPlateDataToXML(punchPlates, settings) {
            // XML Document
            let xml = document.implementation.createDocument(null, "PunchPlates");
            let elements = xml.getElementsByTagName("PunchPlates");

            // Options element
            let options = xml.createElement("Options");
//            options.setAttribute("version", this.backEndData.punchPlateUtilityVersion);
            options.setAttribute("version", "1.5.0");
            if ('polygon-offset' in settings) {
                options.setAttribute("polygonOffset", settings['polygon-offset']);
            } else {
                options.setAttribute("polygonOffset", '0');
            }
            if ('filename-prefix' in settings) {
                options.setAttribute("fileNamePrefix", settings['filename-prefix']);
            } else {
                options.setAttribute("fileNamePrefix", '');
            }
            options.setAttribute("targetDir", this.backEndData.dropBoxLocation);
            elements[0].appendChild(options);

            const nothingSelected = !punchPlates.some(p => p.selected);
            punchPlates.forEach(p => {
                if (nothingSelected || p.selected) {
                    let punchplate = xml.createElement("PunchPlate");
                    punchplate.setAttribute("definition", p.definition);
                    const prefix = settings['label-prefix'] ? settings['label-prefix'] : p.definition.substring(0, 1);
                    punchplate.setAttribute("label", prefix + this.getDefinitionNumber(p.definition));
                    punchplate.setAttribute("thickness", p.thickness);
                    punchplate.setAttribute("quantity", p.instances_in_selection);
                    if (p.fileNameSuffix) {
                        punchplate.setAttribute("fileNameSuffix", p.fileNameSuffix);
                    }

                    if (p.loops) {
                        p.loops.forEach(loopData => {
                            let loop = xml.createElement("Loop");
                            loop.setAttribute("outer", loopData.outer);
                            loopData.loop.forEach(item => {
                                if (item.type === "ArcCurve"){
                                    let arccurve = xml.createElement("ArcCurve");
                                    arccurve.setAttribute("circle", item.circle);
                                    arccurve.setAttribute("x", item.center.x);
                                    arccurve.setAttribute("y", item.center.y);
                                    arccurve.setAttribute("radius", item.radius);
                                    arccurve.setAttribute("start_angle", item.start_angle);
                                    arccurve.setAttribute("end_angle", item.end_angle);
                                    loop.appendChild(arccurve);
                                } else if (item.type === "Vertex"){
                                    let vertex = xml.createElement("Vertex");
                                    vertex.setAttribute("x", item.position.x);
                                    vertex.setAttribute("y", item.position.y);
                                    loop.appendChild(vertex);
                                }
                            });
                            punchplate.appendChild(loop);
                        });
                    }

                    if (p.folds) {
                        p.folds.forEach(f => {
                            f.markers.forEach(m => {
                                let fold = xml.createElement("Fold");
                                fold.setAttribute("x1", m.pt1.x);
                                fold.setAttribute("y1", m.pt1.y);
                                fold.setAttribute("x2", m.pt2.x);
                                fold.setAttribute("y2", m.pt2.y);
                                punchplate.appendChild(fold);
                            });
                        });
                    }

                    elements[0].appendChild(punchplate);
                }
            });

            return (new XMLSerializer()).serializeToString(xml);
        },
        reloadPage() {
            window.location.reload();
        },
        reloadPluginFiles(files) {
            sketchup.reloadFiles(files);
            this.reloadPage();
        },
        sortDefinitions(definitions) {
            definitions.sort(function (a, b) {
                let idxA = a.lastIndexOf('#');
                let idxB = b.lastIndexOf('#');
                if (idxA > -1 &&
                    idxB > -1 &&
                    a.substring(0, idxA) === b.substring(0, idxB) &&
                    !isNaN(parseInt(a.substring(idxA + 1))) &&
                    !isNaN(parseInt(b.substring(idxB + 1)))
                ) {
                    if (parseInt(a.substring(idxA + 1)) < parseInt(b.substring(idxB + 1))) return -1;
                    if (parseInt(a.substring(idxA + 1)) > parseInt(b.substring(idxB + 1))) return 1;
                } else {
                    if (a < b) return -1;
                    if (a > b) return 1;
                }
                return 0;
            });

            return definitions;
        },
    }
}